module.exports = store;


//////////////////
// WEBPACK FOOTER
// external "store"
// module id = jNiS
// module chunks = 2